import { render, staticRenderFns } from "./TemplateTopbar.vue?vue&type=template&id=665e11dc"
import script from "./TemplateTopbar.vue?vue&type=script&lang=ts"
export * from "./TemplateTopbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports